import clsx from "clsx";
import { ReactComponent as SearchIcon } from "assets/icons/search.svg";
import { Input } from "components/Input";
import styles from "./Searchbar.module.scss";

export const Searchbar = ({
  placeholder = "",
  prefix = <SearchIcon />,
  allowClear = false,
  className = "",
  onPressEnter = () => {},
  onChange = () => {},
}) => {
  return (
    <Input
      className={clsx(styles.customSearchbar, className)}
      placeholder={placeholder}
      prefix={prefix}
      allowClear={allowClear}
      onPressEnter={onPressEnter}
      onChange={onChange}
    />
  );
};
